import { types } from "mobx-state-tree"
import { FinanceTransactionSearch } from "./FinanceTransactionSearch";

export const CustomTransactionSearch = types.compose(
    FinanceTransactionSearch,
    types.model({
        finance_transaction_category_id: types.maybe(types.string),
        institution_bank_account_id: types.maybe(types.string),
    })
)